import moment from "moment";

export default {
    data () {
      return {
      };
    },
    methods: {
      formatDate(date, format = 'YYYY-MM-DD', locale = 'en') {
        if (!date) return '';
        moment.locale(locale)

        return moment(date).format(format);
      },
      formatLocalDate(date, format = 'YYYY-MM-DD', locale = 'en') {
        if (!date) return '';
        moment.locale(locale)

        return moment.utc(date).format(format);
      },
      getToday(format = 'YYYY-MM-DD') {
        return moment().format(format);
      },
      isToday(dateParam) {
        let today = this.getToday();
        let date = moment(dateParam).format('YYYY-MM-DD')

        return today == date;
      },
      isTomorrow(dateParam) {
        let today = moment().add(1, 'days').format('YYYY-MM-DD');
        let date = moment(dateParam).format('YYYY-MM-DD')

        return today == date;
      },
      isFutureAndPresent(dateParam) {
        let date = moment(dateParam).format('YYYY-MM-DD')
        let today = moment().format('YYYY-MM-DD')

        return date >= today
      },
      isFuture(dateParam) {
        let date = moment(dateParam).format('YYYY-MM-DD')
        let today = moment().format('YYYY-MM-DD')

        return date > today
      },
      isPast(dateParam) {
        let date = moment(dateParam).format('YYYY-MM-DD')
        let today = moment().format('YYYY-MM-DD')

        return date < today
      },
      addOrSubtractTimeFromDate(number, kind = 'days', type = 'add', date = moment().format('YYYY-MM-DD'), format = 'YYYY-MM-DD') {
        let day;
        if (type == 'add') {
          day = moment(date).add(number, kind).format(format);
        } else {
          day = moment(date).subtract(number, kind).format(format);
        }

        return day;
      },
      getStartOrEndDateThisMonth(time = 'start', format='YYYY-MM-DD') {
        let date;
        if (time == 'start') {
          date = moment().startOf('month').format(format)
        } else {
          date = moment().endOf('month').format(format)
        }

        return date;
      },
      getListDayInMonth(dateParam = this.getToday()) {
        let listOfDay = [];
        let daysInMonth = moment(dateParam).daysInMonth();
        for (let i = 0; i < daysInMonth; i++) {
          listOfDay.push(moment(dateParam).date(i + 1).format('YYYY-MM-DD'));
        }

        return listOfDay;
      },
      getStartOrEndDateTimeWeek(type = 'start', date = this.getToday(), format='YYYY-MM-DD HH:mm:ss') {
        return (type === 'start' ? moment(date).startOf('week') : moment(date).endOf('week').set({h:23, m:59, s:59})).format(format);
      },
      getStartOrEndDateTimeDay(type = 'start', date = this.getToday(), format='YYYY-MM-DD HH:mm:ss', number = 0, kind = 'days') {

        return (type === 'start' ? moment(date).startOf('day') : moment(date).endOf('day').subtract(number, kind).set({h:23, m:59, s:59})).format(format);
      },
      getArrayOfDateRangeFromTo(from_date, to_date) {
        let date_range = [];
        let start_date = new Date(this.formatDate(from_date));
        let end_date = new Date(this.formatDate(to_date));

        while(start_date <= end_date){
          date_range.push(moment(start_date).format('YYYY-MM-DD'));
          let newDate = start_date.setDate(start_date.getDate() + 1);
          start_date = new Date(newDate);
        }

        return date_range;
      },
      getDateTimeFromDateString(date, hour = 0){
        return moment(date).hour(hour)
      },
      listDaysBetweenDates(startDate, endDate) {
        var dates = [];

        var currDate = moment(startDate).startOf('day');
        var lastDate = moment(endDate).startOf('day');
        dates.push(startDate);

        while(currDate.add(1, 'days').diff(lastDate) <= 0) {
          dates.push(currDate.format('YYYY-MM-DD'));
        }

        return dates;
      },
      getDiffTime(startDateTime, endDateTime, type) {
        let start = moment(startDateTime, 'YYYY-MM-DD HH:mm:ss');
        let end = moment(endDateTime, 'YYYY-MM-DD HH:mm:ss');
        let number = end.diff(start, type);

        return number;
      },
      addOrSubtractHours(timeStr, hoursToAddOrSubtract, operationType) {
        let timeMoment = moment(timeStr, "HH:mm:ss");

        if (operationType === 'add' && timeMoment.format("HH:mm:ss") === "23:59:59") {
          return false;
        } else if (operationType === 'subtract' && timeMoment.format("HH:mm:ss") === "00:00:00") {
          return false;
        }

        if (operationType === 'add') {
            timeMoment.add(hoursToAddOrSubtract, 'hours');

            if (timeMoment.isAfter(moment().endOf('day'))) {
              timeMoment = moment().endOf('day');
            }
        } else if (operationType === 'subtract') {
            timeMoment.subtract(hoursToAddOrSubtract, 'hours');
        }

        const resultTime = timeMoment.format("HH:mm:ss");
        return resultTime;
      },
      // 「確認」ボタンの表示条件（その日が３０日前以降か）
      isScheduleConfirmDate(date){
        let sub = moment().add(-30,"days");
        return moment(date).isAfter(sub);
      },
      enddateAsc(endDate1,endDate2,endDate3){
        return [
          endDate1 != null ? this.$moment(endDate1) : null
          , endDate2 != null? this.$moment(endDate2) : null
          , endDate3 != null ? this.$moment(endDate3) : null
        ]
          .slice() // 元配列を変更しないため
          .sort((a, b) => {
            const aTime = a ? a.valueOf() : Number.MAX_SAFE_INTEGER;
            const bTime = b ? b.valueOf() : Number.MAX_SAFE_INTEGER;
            return aTime - bTime;
          });
      }
    },
  };
